class MobileMenu extends HTMLElement {
  connectedCallback() {
    this._releaseFocus = null;
    this._trigger = null;
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-mobile-menu-close]')) this.close();
    });
    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.close();
    };
  }

  open(trigger) {
    this._trigger = trigger || document.activeElement;
    this.hidden = false;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKeydown);
    this._releaseFocus = window.ShirtWerk.trapFocus(this.querySelector('.mobile-menu__panel'));
  }

  close() {
    this.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKeydown);
    if (this._releaseFocus) this._releaseFocus();
    if (this._trigger) this._trigger.focus();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeydown);
  }
}
customElements.define('mobile-menu', MobileMenu);
